/**
 * @param {Function} fn 防抖函数
 * @param {Number} delay 延迟时间
 */
const debounce = (fn, delay) => {
    let timer;
    return function() {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(context, args);
        }, delay);
    };
};

const vh = (px) => {
    const screenH = window.screen.height;
    return (px / 1080) * screenH;
};

const handleTime = (date = new Date()) => {
    let y = date.getFullYear();
    let MM = zeroFill(date.getMonth() + 1);
    let dd = zeroFill(date.getDate());
    // let hh = zeroFill(date.getHours());
    // let mm = zeroFill(date.getMinutes());
    // let ss = zeroFill(date.getSeconds());
    return `${y}年${MM}月${dd}日`;
};

const zeroFill = (time) => {
    return +time < 10 ? `0${time}` : time;
};

const fontSize = (res) => {
    const innerHeight =
        window.innerHeight ||
        document.documentElement.innerHeight ||
        document.body.innerHeight;
    return (res / 1080) * innerHeight;
};
/**
 * 字体大小，带单位
 * px 设计图大小
 * */

const fontVh = (px) => {
    return (Number(px) / 1080) * 100 + "vh";
};

/**
 * 自动补全
 * @author DZQ
 * @param {Integer} value 需要补全的数字
 * @param {Integer} number 返回的位数
 */
const paddingZero = function(value, number) {
    return ("0000000" + value).slice(-number);
};

/**
 * 格式化时间
 * @function formatTime 格式化时间
 * @param {Date} date 需要被格式化的时间对象
 * @param {String} format 格式 {
 *     yyyy 表示年
 *     [MM | M] 表示月 [ 两位数字 | 一或两位数字 ]
 *     [dd | d] 表示日 [ 两位数字 | 一或两位数字 ]
 *     [HH/hh | H/h] 表示时 [ 两位数字 | 一或两位数字 ]
 *     [mm | m] 表示分 [ 两位数字 | 一或两位数字 ]
 *     [ss | s] 表示秒 [ 两位数字 | 一或两位数字 ]
 * }
 * @return {String} 返回被格式化的时间文本
 */
const formatTime = function(date = new Date(), format = "") {
    let y = date.getFullYear();
    let MM = paddingZero(date.getMonth() + 1, 2);
    let dd = paddingZero(date.getDate(), 2);
    let hh = paddingZero(date.getHours(), 2);
    let mm = paddingZero(date.getMinutes(), 2);
    let ss = paddingZero(date.getSeconds(), 2);
    if (format === "") {
        return `${y}/${MM}/${dd} ${hh}:${mm}:${ss}`;
    } else {
        let dateString = format;
        if (/yyyy/.test(format)) {
            dateString = dateString.replace("yyyy", y);
        }
        if (/MM/.test(format)) {
            dateString = dateString.replace("MM", MM);
        }
        if (/M/.test(format)) {
            dateString = dateString.replace("M", date.getMonth() + 1);
        }
        if (/dd/.test(format)) {
            dateString = dateString.replace("dd", dd);
        }
        if (/d/.test(format)) {
            dateString = dateString.replace("d", date.getDate());
        }
        if (/HH/.test(format) || /hh/.test(format)) {
            dateString = dateString.replace("HH", hh);
            dateString = dateString.replace("hh", hh);
        }
        if (/H/.test(format) || /h/.test(format)) {
            dateString = dateString.replace("H", date.getHours());
            dateString = dateString.replace("h", date.getHours());
        }
        if (/mm/.test(format)) {
            dateString = dateString.replace("mm", mm);
        }
        if (/m/.test(format)) {
            dateString = dateString.replace("m", date.getMinutes());
        }
        if (/ss/.test(format)) {
            dateString = dateString.replace("ss", ss);
        }
        if (/s/.test(format)) {
            dateString = dateString.replace("s", date.getSeconds());
        }
        return dateString;
    }
};
/***
 *获取当天是星期几
 *
 */
 const getWeek = function (weeks) {
    let tody = weeks.split('-');
    tody = tody.join('/');
    let date = new Date(tody);
    let day = date.getDay();
    let weekDay = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
    let week = weekDay[day];
    return week;
}
// 对象数组中根据属性值大小排序:property是属性名，desc是一个bool值，desc为true是升序排列 ，desc为false是降序排列
const compare = function(property, desc) {
    return function(a, b) {
        let value1 = a[property];
        let value2 = b[property];
        if (desc == true) {
            //排序升序排列
            return value1 - value2;
        } else {
            return value2 - value1;
        }
    };
};
/**
 * 数字转化成正数
 * digit保留几位数
 * unit 单位
 * */
const tranNumber = (num, digit = 1, unit = "元") => {
    const numStr = num.toString();
    const numSplit = numStr.split(".")[0];
    const roundNum = parseInt(num);
    const m = Math.pow(10, digit);
    if (numSplit.length <= 4) {
        return {
            price: numStr,
            unit
        };
    } else if (numSplit.length > 4 && numSplit.length <= 8) {
        const average = roundNum / 10000;
        const round = parseInt(average * m) / m;
        return {
            price: round,
            unit: "万" + unit
        };
    }
    // else if (numSplit.length == 8) {
    //     const average = roundNum / 10000000;
    //     const round = parseInt(average * m) / m;
    //     return {
    //         price: round,
    //         unit: "千万" + unit
    //     };
    // }
    else if (numSplit.length >= 9) {
        const average = roundNum / 100000000;
        const round = parseInt(average * m) / m;
        return {
            price: round,
            unit: "亿" + unit
        };
    }
};
// 四舍五入保留2位小数（不够位数，则用0替补）
const keepTwoDecimalFull = (num) => {
    let result = parseFloat(num);
    result = Math.round(num * 100) / 100;
    let s_x = result.toString(); //将数字转换为字符串
    let pos_decimal = s_x.indexOf("."); //小数点的索引值
    // 当整数时，pos_decimal=-1 自动补0
    if (pos_decimal < 0) {
        pos_decimal = s_x.length;
        s_x += ".";
    }
    // 当数字的长度< 小数点索引+2时，补0
    while (s_x.length <= pos_decimal + 2) {
        s_x += "0";
    }
    return s_x;
}
// 四舍五入保留2位小数（不够位数，则用0替补）
const filterTime = (date) => {
    let tMoth;
    let tTime;
    tMoth = (date.substring(0, 10)).split('-');
    tMoth[0] = `${tMoth[0]}年`
    tMoth[1] = `${tMoth[1]}月`
    tMoth[2] = `${tMoth[2]}日`
    tTime = tMoth.join('') + date.substring(10, 16)
    return tTime
}

// 获取url中携带的参数(整合成对象)
const getQueryObjByUrl = () => {
    try {
        const itemArr = window.location.href.split('?')[1].split('&')
        const itemObj = {}
        itemArr.forEach(itemVal => {
            const [key, value] = itemVal.split('=')
            itemObj[key] = value
        })
        return itemObj
    } catch (error) {
        console.log(error)
        return {}
    }
}

export {
    getQueryObjByUrl,
    zeroFill,
    debounce,
    vh,
    handleTime,
    fontSize,
    fontVh,
    formatTime,
    compare,
    tranNumber,
    keepTwoDecimalFull,
    filterTime,
    getWeek
};
